$(function () {
    // Função para abrir accordion se o elemento estiver dentro de um
    function openAccordionIfNeeded(targetElement) {
        // Verifica se o elemento está dentro de um accordion collapse
        var accordionCollapse = targetElement.closest('.accordion-collapse')

        if (accordionCollapse.length) {
            // Remove a classe 'show' de todos os accordions do mesmo grupo
            var accordionParent = accordionCollapse.closest('.accordion')
            if (accordionParent.length) {
                accordionParent.find('.accordion-collapse').removeClass('show')
                accordionParent
                    .find('.accordion-button')
                    .addClass('collapsed')
                    .attr('aria-expanded', 'false')
            }

            // Adiciona a classe 'show' no accordion alvo
            accordionCollapse.addClass('show')

            // Atualiza o botão do accordion
            var accordionButton = accordionCollapse
                .prev('.accordion-header')
                .find('.accordion-button')
            if (accordionButton.length) {
                accordionButton.removeClass('collapsed')
                accordionButton.attr('aria-expanded', 'true')
            }

            return true // Retorna true se encontrou accordion
        }

        // Se o próprio elemento for um wrapper de accordion
        var accordionInside = targetElement.find('.accordion-collapse').first()

        if (accordionInside.length) {
            accordionInside.addClass('show')
            var accordionButton = accordionInside
                .prev('.accordion-header')
                .find('.accordion-button')
            if (accordionButton.length) {
                accordionButton.removeClass('collapsed')
                accordionButton.attr('aria-expanded', 'true')
            }
            return true
        }

        return false // Não encontrou accordion
    }

    // Função para fazer o scroll até o elemento
    function scrollToElement(targetElement) {
        if (targetElement.length) {
            // Abre o accordion se necessário
            var hasAccordion = openAccordionIfNeeded(targetElement)

            // Aguarda o accordion abrir antes de fazer o scroll (se tiver accordion)
            var delay = hasAccordion ? 350 : 0

            setTimeout(function () {
                var headerOffset = $('#header-bar').outerHeight() || 0
                var targetPosition =
                    targetElement.offset().top - headerOffset - 20

                $('html, body').animate(
                    {
                        scrollTop: targetPosition,
                    },
                    800
                )
            }, delay)
        }
    }

    // Scroll to anchor on page load
    if (window.location.hash) {
        var hash = window.location.hash
        var targetElement = $(hash)

        if (targetElement.length) {
            // Pequeno delay para garantir que a página carregou
            setTimeout(function () {
                scrollToElement(targetElement)
            }, 100)
        }
    }

    // Smooth scroll para links com âncora na mesma página
    $('a[href*="#"]').on('click', function (e) {
        // Ignora elementos com data-bs-toggle e links com classe no-smooth-scroll
        if ($(this).attr('data-bs-toggle') || $(this).hasClass('no-smooth-scroll')) {
            return
        }

        var hash = this.hash

        if (hash && hash !== '#' && hash !== '#0') {
            var targetElement = $(hash)

            if (targetElement.length) {
                e.preventDefault()
                scrollToElement(targetElement)

                // Atualiza a URL
                history.pushState(null, null, hash)
            }
        }
    })

    // Sticky header
    var observer = new IntersectionObserver(
        function (entries) {
            // no intersection with screen
            if (0 === entries[0].intersectionRatio) {
                document.querySelector('#header-bar').classList.add('sticky')
            }

            // fully intersects with screen
            else if (1 === entries[0].intersectionRatio) {
                document.querySelector('#header-bar').classList.remove('sticky')
            }
        },
        {
            threshold: [0, 1],
        }
    )

    observer.observe(document.querySelector('#sticky-menu-top'))

    // Masks
    var maskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11
                ? '(00) 00000-0000'
                : '(00) 0000-00009'
        },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskBehavior.apply({}, arguments), options)
            },
        }
    $('.form-tel').mask(maskBehavior, options)
    $('.form-cep').mask('00000-000')
    $('.form-data').mask('00/00/0000')

    // CEP autofill
    $('#form-cep').on('focusout', function () {
        $.ajax({
            url: 'https://viacep.com.br/ws/' + $(this).val() + '/json/unicode/',
            dataType: 'json',
            success: function (resposta) {
                $('#form-endereco').val(resposta.logradouro)
                $('#form-complemento').val(resposta.complemento)
                $('#form-bairro').val(resposta.bairro)
                $('#form-cidade').val(resposta.localidade)
                $('#form-uf').val(resposta.uf)
                $('#form-numero').focus()
            },
        })
    })

    // Fixed Sidebar
    $('.fixed-sidebar').append('<div class="container-offset"></div>')

    // Get container offset
    offsetWidth()
    $(window).on('resize', function () {
        offsetWidth()
    })

    function offsetWidth() {
        var containerOffset = $('.container').offset().left
        $('.container-offset').css('width', containerOffset + 12)
    }

    // Fancybox
    Fancybox.bind()

    // Toggle Site Map
    $('.site-map-button').on('click', function (event) {
        event.preventDefault()
        $(this).toggleClass('show')
        $('.site-map-toggle').slideToggle()
    })

    // Enable tooltip
    const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
    )
    const tooltipList = [...tooltipTriggerList].map(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
    )

    // Third Level Menu Mobile
    // $(
    //     '.header-menu .navbar-nav .menu-item-has-children .dropdown-menu .nav-link'
    // ).click(function (event) {
    //     event.preventDefault()

    //     var dropdownMenu = $(this).siblings('.dropdown-menu')
    //     if (dropdownMenu.length > 0) {
    //         dropdownMenu.css('display', 'block')
    //     }
    // })

    // Redirect after Contact Form 7 submission
    document.addEventListener(
        'wpcf7mailsent',
        function (event) {
            if (event.detail.contactFormId == '5107') {
                window.location.href =
                    'http://200.198.23.186/levantamentos-aerogeofisicos-download/'
            }
        },
        false
    )
})
